import React, {useEffect, useState} from 'react';
import {Badge, Button, FileInput, Flex, NumberInput, Textarea} from "@mantine/core";
import cx from "classnames";
import gridStyles from "../../components/layout/sharedStyles/grid.module.css";
import useIsMobile from "../../hooks/useIsMobile";
import Compressor from 'compressorjs';


const Base64 = () => {
  const isMobile = useIsMobile()
  const [base64, setBase64] = useState<string>('')

  const [file, setFile] = useState<File | null>(null);

  const [quality, setQuality] = useState<number>(0.6)
  const [maxH, setMaxH] = useState<number>(300)
  const [maxW, setMaxW] = useState<number>(300)

  const handleFileChange = (file: File | null) => {
    if (file) {
      new Compressor(file, {
        quality: quality,
        maxHeight: maxH,
        maxWidth: maxW,
        success(result) {
          fileToBase64(result)
        }
      })
    } else {
      setBase64('')
    }
  }

  const fileToBase64 = (file: File | Blob) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result as string

      // Extract base64 string without prefix
      const base64String = result || ""//result.split(',')[1] || ''

      setBase64(base64String)
    }
    reader.readAsDataURL(file)
  }

  const handleCopy = () => {
    if (base64 && navigator.clipboard) {
      navigator.clipboard.writeText(base64).catch((err) => {
        console.error('Failed to copy Base64 to clipboard', err);
      });
    }
  }

  useEffect(() => {
    handleFileChange(file)
  }, [file, quality, maxH, maxW])

  return (
    <div className={cx(gridStyles.grid, {[gridStyles.mobile]: isMobile})}>
      <div>
        <FileInput
          label="Image"
          description=""
          onChange={setFile}
          placeholder="Select image (click here)"
        />

        <Flex gap="1rem" mt="xl">
          <NumberInput
            label="Quality"
            defaultValue={quality}
            onChange={(val) => setQuality(parseFloat(val?.toString() || "0"))}
            min={0} step={0.1} max={1}
          />
          <NumberInput
            label="maxHeight"
            defaultValue={maxH}
            onChange={(val) => setMaxH(parseInt(val?.toString() || "0"))}
            min={0}
          />
          <NumberInput
            label="maxWidth"
            defaultValue={maxW}
            onChange={(val) => setMaxW(parseInt(val?.toString() || "0"))}
            min={0}
          />
        </Flex>
      </div>
      <div>
        <div>
          {base64 && (
            <img src={base64} alt=""/>
          )}
        </div>
        <Badge color="blue">{base64.length} chars</Badge>
        <Badge color="blue">{quality} q</Badge>
        <Badge color="blue">max {maxH}x{maxW}</Badge>
        <Textarea
          readOnly
          value={base64}
          autosize
          onClick={handleCopy}
          maxRows={20}
          mt="md"
          placeholder="Select image to get base64..."
        />
        <Button variant="default" mt="1rem" onClick={handleCopy}>Copy</Button>
      </div>
    </div>
  )
}

export default Base64